import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserProfileService {

    apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getUsers(paramsObj: any) {
        let params = new HttpParams();

        if (paramsObj) {
            Object.keys(paramsObj).forEach(key => {
                const value = paramsObj[key];
                if (value !== null && value !== undefined && value !== '') {
                    params = params.set(key, value);
                }
            });
        }
        const url = this.apiUrl + '/bulk-estamp/user-list';
        return this.http.get<any>(url, { params }).pipe(
            map((res: any) => ({ ...res, totalCount: res?.meta?.total }))
        )
    }

    getUserDetail(userId: string) {
        const url = this.apiUrl + `/bulk-estamp/user/${userId}`;
        return this.http.get<any>(url)
    }

    approvedStates(id: string): Observable<any> {
        return this.http.patch(`${this.apiUrl}/bulk-estamp/user/approve/${id}`, {});
    }
    rejectedStateReq(data: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/bulk-estamp/user/reject`, data);
    }

    getStates(role: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/bulk-estamp/states`);
    }

    assignMaker( data: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/bulk-estamp/client-user-mapping`, data);
    }

}
